import React from 'react'

import { TtSkeleton } from '@23/ui-react'

import './PublicVideoPreviewPageSkeleton.scss'

export const PublicVideoPreviewPageSkeleton = () => (
  <div className="public-video-preview-skeleton">
    <div className="public-video-preview-skeleton-main">
      <div className="public-video-preview-skeleton-content">
        <TtSkeleton className="public-video-preview-skeleton-player" />
        <TtSkeleton className="public-video-preview-skeleton-text" />
        <TtSkeleton className="public-video-preview-skeleton-text" />
      </div>

      <div className="public-video-preview-skeleton-widgets">
        <TtSkeleton className="public-video-preview-skeleton-widget" />
        <TtSkeleton className="public-video-preview-skeleton-widget" />
      </div>
    </div>
  </div>
)
